export default __webpack_public_path__ + "static/media/video.30c720ef.svg";